var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium",
    transform: "translate(-1031, -4725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1031, 4725)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#F3F3F3",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-clock-7016980",
    transform: "translate(8, 7)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C4.03714286,0 0,4.03714286 0,9 C0,13.9628571 4.03714286,18 9,18 C13.9628571,18 18,13.9628571 18,9 C18,4.03714286 13.9628571,0 9,0 Z M12.9,9 L8.7,9 C8.3699904,9 8.1,8.7300096 8.1,8.4 L8.1,4.2 C8.1,3.8699904 8.3699904,3.6 8.7,3.6 C9.0300096,3.6 9.3,3.8699904 9.3,4.2 L9.3,7.8 L12.9,7.8 C13.2300096,7.8 13.5,8.0699904 13.5,8.4 C13.5,8.7300096 13.2300096,9 12.9,9 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconGrey);
export default __webpack_public_path__ + "static/media/clock-icon--grey.81a0d99c6daffceca76f77dc269c9fa4.svg";
export { ForwardRef as ReactComponent };